import posed from 'react-pose';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const MaskAnimation = posed.div({
  enter: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 200,
    },
  },
});

export const Mask = styled(MaskAnimation)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${themeGet('colors.blacks.6')};
  z-index: ${themeGet('zIndex.fixed')};
`;
